import cssLogo from '../assets/CompanyLogos/CSSLab-logo.png'
import dcaaLogo from '../assets/CompanyLogos/DCAA-logo.png'
import nasaLogo from '../assets/CompanyLogos/NASA-logo.png'
import perLogo from '../assets/CompanyLogos/PER-logo.png'
import usacoLogo from '../assets/CompanyLogos/USACO-logo.png'
import vspLogo from '../assets/CompanyLogos/VSP-logo.png'
import pennappsLogo from '../assets/CompanyLogos/PennApps-logo.png'
import pennlabsLogo from '../assets/CompanyLogos/PennLabs-logo.png'
import codejamLogo from '../assets/CompanyLogos/GoogleCodeJam-logo.png'
import citadelLogo from '../assets/CompanyLogos/Citadel-logo.png'
import firstLogo from '../assets/CompanyLogos/First-logo.png'
import janestreetLogo from '../assets/CompanyLogos/JaneStreet-logo.png'

import nasaLogoBW from '../assets/CompanyLogos/NASA-logo-bw.png'
import dcaaLogoBW from '../assets/CompanyLogos/DCAA-logo-bw.png'

export const timelineEntries = [
  {
    title: "Software Engineer Intern @ Jane Street",
    highlight: "Jane Street",
    date: "Jun 2024 - Aug 2024",
    description: [
      "OCaml"
    ],
    logo: janestreetLogo
  },
  {
    title: "Software Engineer Intern @ Citadel",
    highlight: "Citadel",
    date: "Jun 2023 - Aug 2023",
    description: [
      "Global Clearing & Settlements Team",
      "Java, Spring Boot, Kubernetes, gRPC, Kafka"
    ],
    logo: citadelLogo,
  },
  {
    title: "Software Developer @ Penn Labs",
    highlight: "Penn Labs",
    date: "Sep 2022 - Present",
    description: [
      "Design, plan and develop features for Penn Mobile backend API with 10K+ monthly users.",
      "Django REST"
    ],
    logo: pennlabsLogo,
  },
  {
    title: "Lead Software Developer @ PennApps",
    highlight: "PennApps",
    date: "May 2022 - Present",
    description: [
      "Manage 10+ engineers to build products for Hackathon. Lead 3 projects to completion including Application Portal rebuild.",
        "Django REST, AWS, React, Gatsby"
    ],
    logo: pennappsLogo,
  },
  {
    title: "Software Engineer Intern @ VSP Global",
    highlight: "VSP Global",
    date: "May 2022 - Aug 2022",
    description: [
      "Full stack development in scrum environment on Client Broker Portal team to support web apps for internal/external users to sell insurance.",
      "Java, Angular"
    ],
    logo: vspLogo,
  },
  {
    title: "Google Code Jam Round 2 Qualifier",
    highlight: "Google Code Jam",
    date: "May 2022",
    description: [
      "Ranked 2290 out of 30K+ competitors in international programming competition."
    ],
    logo: codejamLogo,
  },
  {
    title: "Research Assistant @ Computational Social Science Lab",
    highlight: "Computational Social Science Lab",
    date: "Dec 2021 - May 2022",
    description: [
      "Created digital experiments through the Emperica.ly framework to conduct research on group dynamics.",
      "React, Meteor"
    ],
    logo: cssLogo,
  },
  {
    title: "Software Developer @ Penn Electric Racing",
    highlight: "Penn Electric Racing",
    date: "Sep 2021 - May 2022",
    description: [
      "Dabbled with embedded programing + wrote peripheral interfaces in Rust."
    ],
    logo: perLogo,
  }, 
  {
    title: "Java/Algorithms Teacher @ DCAA Chinese School",
    highlight: "DCAA Chinese School",
    date: "Sep 2020 - May 2021",
    description: [
      "Taught a course covering Java and introduction to algorithms to middle/high school students."
    ],
    logo: dcaaLogo,
    bwLogo: dcaaLogoBW
  },
  {
    title: "Research Intern @ NASA Jet Propulsion Labratory",
    highlight: "NASA Jet Propulsion Labratory",
    date: "May 2020 - Aug 2020",
    description: [
      "Analyzed simulated exoplanet time series models to detect rotation periods, summarized in 20 page report.",
      "Python, SciPy, NumPy, Matplotlib."
    ],
    logo: nasaLogo,
    bwLogo: nasaLogoBW
  },
  {
    title: "Platinum Level USA Computing Olympiad Competitor",
    highlight: "USA Computing Olympiad",
    date: "Dec 2019 - Dec 2020",
    description: [
      "Top ~250 U.S. students in international computing competition.",
    ],
    logo: usacoLogo,
  },
  {
    title: "FTC Robotics Team 14296 Lead Developer",
    highlight: "FTC Robotics",
    date: "Aug 2018 - May 2021",
    description: [
      "Designed overall codebase and scored 90% of autonomous points using computer vision, odometry feedback, and path finding.",
    ],
    logo: firstLogo
  }
]